// // import { ASSETS_CDN } from './common'
// import {assetCDN} from '~/helper/index.js'

// const ASSETS_CDN = assetCDN()
const TOP_BAR_TEXT = 'Private Group Tours: Your Vision, Our Expertise, Endless Possibilities.'
const TOP_BAR_CTA = 'Start Designing Now!'
const HERO_TITLE = 'Private Group Tours: Tailor Made Journeys for You and Your Clients'
const HERO_TEXT = `Welcome to Private Group Tours by Designer Journeys, a unique offering exclusively designed for busy travel agents who would like help designing private group tours for their clients.`
const HERO_CTA = 'Start Designing Now'
const HERO_ITEMS = (cdn) => [
    {
        title: `258+ designers`,
        content: `Our Network of Local Designers`,
        icon: `${cdn}/icons/groups_three-white.svg`,
    },
    {
        title: `75 countries`,
        content: `Global Extraordinary Experience Await`,
        icon: `${cdn}/icons/globe.svg`,
    },
    {
        title: `94.07%`,
        content: `Satisfaction Rating`,
        icon: `${cdn}/icons/satisfied-white.svg`,
    }
]
const DIFFERENCE_HEADER = 'The Designer Journeys Difference'
const DIFFERENCE_SUBHEADER = 'Here’s what Designer Journeys has to offer'
const DIFFERENCE_CONTENT = [
    {
        title: `Access a World of Extraordinary Experiences`,
        content: `We offer access to thousands of unique experiences - that can only be accessed by those with deep local knowledge.`,
        src: 'custom-group-tours-difference-3',
    },
    {
        title: `Your Vision, our Expertise:<br/> the Perfect Tour`,
        content: `With our Private Group Tours, you can provide the ideas and we'll provide the expertise to create the perfect tour for your clients.`,
        src: 'custom-group-tours-difference-1',
    },
    {
        title: `Travel with Confidence,<br/> Every Step of the Way`,
        content: `We are industry accredited, provide complete financial protection, and offer unparalleled in-country support from our local designers.`,
        src: 'custom-group-tours-difference-2',
    },
]

const BENEFITS_HEADER = `
Benefits of using Designer Journeys to
<br />
Create your Private Group Tour`
const BENEFITS_SUBHEADER = 'Discover the Advantages of choosing Designer Journeys for your Private Group Tour.'
const BENEFITS_FIRST_LIST = (cdn) => [
    {
        title: `Tailor-Made Group Experiences`,
        content: `Designer Journeys specializes in creating tailor-made group experiences that cater to the specific interests and needs of your clients, no matter how unique they may be.`,
        icon: `${cdn}/icons/gpp-v2.svg`,
    },
    {
        title: `Optional Included <br/> Host Places`,
        content: `We appreciate that travel agents may want to accompany their clients on the trip. We offer the option for travel agents to act as tour hosts and can include this in the price.`,
        icon: `${cdn}/icons/autopay-v2.svg`,
    },
    {
        title: `In-destination support <br/> for your clients`,
        content: `Local Designers offer personalized in-destination support throughout your clients' Private Group Trip, helping them to make the most of their experience and ensuring they have a seamless journey.`,
        icon: `${cdn}/icons/groups_three-v2.svg`,
    },
]
const BENEFITS_SECOND_LIST = (cdn) => [
    {
        title: `Competitive Pricing <br/>and Value`,
        content: `Designer Journeys is committed to offering competitive pricing without compromising on quality. We leverage our extensive network of trusted suppliers and partners to provide exceptional value for our private group tours.`,
        icon: `${cdn}/icons/request_quote-v2.svg`,
    },
    {
        title: `Global network of <br/>trusted Local Designers`,
        content: `Our network of over 250 Local Designers across 75 countries have extensive knowledge of their respective destinations and can help you create itineraries that are tailored to your clients' specific interests.`,
        icon: `${cdn}/icons/person_play-v2.svg`,
    },
    {
        title: `Net Pricing and <br/>Flexible Margin`,
        content: `Designer Journeys enables travel agents to have full control over pricing the trip for their clients. This flexibility ensures agents can set competitive prices based on their market analysis, target audience, and desired profit margins.`,
        icon: `${cdn}/icons/satisfied-v2.svg`,
    },
]

const HIW_HEADER = 'How it works'
const HIW_SUBHEADER = 'Here’s what Designer Journeys has to offer'
const HIW_CONTENT = (cdn) => [
    {
        icon: `${cdn}/icons/programmingarrows-v2.svg`,
        title: 'Discover and Explore',
        content: `Explore our gallery of inspiring itineraries or share preferences to find the perfect trip for your clients' next adventure.`,
    },
    {
        icon: `${cdn}/icons/send-v2.svg`,
        title: 'Submit an Enquiry',
        content: `Submit an enquiry through our dedicated form, providing details like group size, departure month, suggested itineraries, and budgets.`,
    },
    {
        icon: `${cdn}/icons/customise-v2.svg`,
        title: 'Collaborate and Customise',
        content: `Partner with our Travel Concierge and local designers to customise the itinerary, creating a unique and memorable journey aligned with your vision.`,
    },
    {
        icon: `${cdn}/icons/emojihappy-v2.svg`,
        title: 'Market and Sell',
        content: `Market your private group tour with the finalized itinerary featuring your branding, and let us know if you need any extra marketing materials.`,
    },
]
const CONTACT_US_HEADER = 'Contact our dedicated team to create unforgettable travel experiences for your clients.'
const CONTACT_US_SUBHEADER = 'Contact Us for Personalised Guidance'
const CONTACT_US_CTA = 'Contact Us'
const REVIEWS_HEADER = 'See What our Travellers Have to Say'
const REVIEWS_SUBHEADER = `At Designer Journeys, we know that we all travel differently. That's why you decide where you travel, how you travel and your travel experiences when you design your trip with us.`
const REVIEWS_NOTE = `More than 861 satisfied customers`
const REVIEWS_CONTENT = [
    {
        country: 'Australia',
        date: 'May 25, 2023',
        content: `Upon arrival, my personal guide greeted me warmly and showed a deep understanding of both local culture and impeccable style. Designer Journey had curated a tailor-made itinerary that allowed me to connect with local designers and immerse myself in the world of creativity. Throughout the trip, I had the opportunity to meet talented designers and visit their studios, gaining insight into their unique creations. Designer Journey's selection of locations showcased a diverse range of design experiences, from buzzing fashion districts to hidden gems in cozy neighborhoods.`,
        name: 'Sean and Merle R.',
        type: 'Traveller',

    }
]

const FAQ_HEADER = 'Frequently asked questions'
const FAQ_SUBHEADER = `Got questions about Designer Journeys' Private Group Tours? We're here and more than happy to assist you!`
const FAQ_CONTENT = [
    {
        question: 'What do you need from me to start designing a Private Group Tour?',
        answer: `To start designing a Private Group Tour, we need as much detail as possible through the enquiry form. Please provide us with the estimated group size, preferred departure month, budget guidelines, any special requirements, and, if available, sample itineraries or links to preferred tours. This information allows us to create a tailored itinerary that aligns with your group's needs, preferences, and required experience. The more detail you can provide in the initial enquiry, the better, and quicker, we can start designing the best trip for you!`,
    },
    {
        question: `What's my role in tour creation?`,
        answer: `Your role involves sharing your clients' preferences, activities, and group size. We handle all the planning, logistics, and itinerary design.`
    },
    {
        question: `Can you manage larger groups?`,
        answer: `Certainly. We're equipped to manage groups of varying sizes, whether it's a small intimate gathering or a large group of 20+`
    },
    {
        question: `Why choose Designer Journeys partnership`,
        answer: `We offer secure, competitively priced, flexible travel solutions with local support and opportunities for personal escort throughout the tour.`
    },
    {
        question: `How do I start tour planning?`,
        answer: `Start by filling our enquiry form detailing group size, departure month, proposed itineraries, and budgets. We'll handle the rest.`
    }
]
const FAQ_CONTACT_HEADER = `Still have questions?`
const FAQ_CONTACT_SUBHEADER = `Can’t find the answer you’ve been looking for? Talk to our friendly support team!`
const FAQ_CONTACT_CTA = `Contact us`
export {
    TOP_BAR_TEXT,
    TOP_BAR_CTA,
    HERO_TITLE,
    HERO_CTA,
    HERO_TEXT,
    HERO_ITEMS,
    DIFFERENCE_HEADER,
    DIFFERENCE_SUBHEADER,
    DIFFERENCE_CONTENT,
    BENEFITS_HEADER,
    BENEFITS_SUBHEADER,
    BENEFITS_FIRST_LIST,
    BENEFITS_SECOND_LIST,
    HIW_HEADER,
    HIW_SUBHEADER,
    HIW_CONTENT,
    CONTACT_US_HEADER,
    CONTACT_US_SUBHEADER,
    CONTACT_US_CTA,
    REVIEWS_HEADER,
    REVIEWS_SUBHEADER,
    REVIEWS_NOTE,
    REVIEWS_CONTENT,
    FAQ_HEADER,
    FAQ_SUBHEADER,
    FAQ_CONTENT,
    FAQ_CONTACT_HEADER,
    FAQ_CONTACT_SUBHEADER,
    FAQ_CONTACT_CTA,
}
